import SnackMessages from './SnackMessages.vue'
import Vue, { VueConstructor } from 'vue'

declare module 'vue/types/vue' {
  interface Vue {
    $snackMessages: typeof SnackMessagesStore
  }
}

const SnackMessagesStore = Vue.observable({
  // eslint-disable-next-line @typescript-eslint/no-array-constructor
  objects: Array(),
  add (obj: any) {
    this.objects.push(obj)
  },
  findIndex (obj: any) {
    return this.objects.findIndex(el => el.id === obj.id)
  },
  remove (obj: any) {
    const index = this.findIndex(obj)
    this.objects.splice(index, 1)
  },
  update (obj: any, content: any) {
    const index = this.findIndex(obj)
    const item = this.objects[index]
    const updated = {
      ...item,
      ...content
    }
    this.objects[index] = updated
    Vue.set(this.objects, index, updated)
  }
})

const SnackMessagesPlugin = {
  install: (vue: VueConstructor) => {
    vue.prototype.$snackMessages = SnackMessagesStore
    vue.component('snack-messages', SnackMessages)
  }
}

export default SnackMessagesPlugin
